import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ModalCompleteInformationPageRoutingModule } from './modal-complete-information-routing.module';

import { ModalCompleteInformationPage } from './modal-complete-information.page';
//Components
import { ComponentsModule } from 'src/app/components/components.module'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ComponentsModule,
    ModalCompleteInformationPageRoutingModule
  ],
  declarations: [ModalCompleteInformationPage]
})
export class ModalCompleteInformationPageModule {}
